module.exports = __webpack_public_path__ + "img/mindmethod-circle.6655442e.png";